<template lang="pug">
.ticket-card(@click="$emit('clicked')" :class="{'active': active}")
  .head
    .title
      member-icon(v-if="ticket.grade" :grade="ticket.grade")
      span {{ticket.title}}
    .cost
      span(v-if="ticket.point") {{ticket.point}}{{$t('reservation.word.point')}}
      span(v-if="ticket.money") +￥{{ticket.money}}
  .body
    ul
      li(v-for="l in ticket.body") {{l}}
      li
        span 包含所有展项
        // a(@click="toIntro") 所有展项
      li(v-if="ticket.money > 0")
        //- span 为
        //- a(@click="setShowCharityPopup(true)") 加油木兰计划
        //- span 捐赠1元
        span 所有收入将用于支付宝公益项目
</template>
<script>
import Member from '@/components/wedgits/Member'
import MemberIcon from '@/components/wedgits/MemberIcon'
import { mapMutations } from 'vuex'
export default {
  name: 'TicketCard',
  components: { MemberIcon, Member },
  props: {
    ticket: {},
    active: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setShowCharityPopup', 'setRouterBack']),
    toIntro() {
      this.$router.replace('/introduction/intro')
      this.setRouterBack('/reservation/res2')
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.ticket-card
  background: #FFFFFF
  box-shadow: -7px -7px 12px 0 rgba(255,255,255,0.02), -13px -7px 16px 0 rgba(252,252,252,0.74), -8px 6px 12px 0 rgba(252,252,252,0.35), 2px 9px 30px 0 rgba(228,228,228,0.80)
  border-radius: 8px
  padding: pxToRem(38) pxToRem(30)
  margin-bottom: pxToRem(40)
  transition: all 0.3s ease
  &.active
    background-image: linear-gradient(135deg, #168BFF 0%, #1664FF 100%)
    box-shadow: 2px 13px 23px -10px rgba(22,139,255,0.60)
    border-radius: 8px
    .head
      .title
        color: white
      .cost
        color: white
    .body
      ul
        li
          color: white
          &:before
            color: white
          a
            text-decoration: underline white

  .head
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between
    flex-direction: row
    .title
      font-size: pxToRem(30)
      color: black
      display: flex
      align-items: center
      flex-direction: row
    .cost
      font-size: pxToRem(30)
      color: $cl-orange
  .body
    ul
      li
        font-size: pxToRem(26)
        color: $cl-gray
        padding-left: pxToRem(26)
        position: relative
        &:before
          content: "\2022"
          color: $cl-gray
          font-weight: bold
          display: inline-block
          //width: pxToRem(10)
          position: absolute
          left: 0
</style>
